// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1CJSd","actions":"GroupTable_actions__1PtpF","deleteModalFooter":"GroupTable_deleteModalFooter__1rC8Y"};